import * as React from 'react';
import { DriveFileRenameOutline } from '@mui/icons-material';
import { useAuth } from '../../../contexts';
import {
  ApplicationViewList,
  type ApplicationViewListProps,
  type TableColumns,
  type FilterFields,
  type CustomAction,
  type ApplicationViewTableDataItem,
} from '../../Application/components/ApplicationViewList';
import {
  supervisorApplicationListFilter,
  supervisorToDoFilter,
} from './filters';
import { APPLICATION_STATUS_TYPE } from '../../../utils';

export const SupervisorApplicationList: React.FunctionComponent = () => {
  const { user } = useAuth();

  const handleEditNomination = (row: ApplicationViewTableDataItem): void => {
    const { applicationStatusRaw, applicationId, nominationId } = row;
    if (applicationStatusRaw) {
      if (!nominationId) {
        window.open(`/internal/create-nomination/${applicationId}`);
      } else {
        window.open(`/internal/nomination/${nominationId}`);
      }
    }
  };

  const customActions: CustomAction[] = [
    {
      icon: <DriveFileRenameOutline />,
      handleAction: handleEditNomination,
      checkDisable: row => {
        const status = row.applicationStatusRaw;
        return !(
          status === APPLICATION_STATUS_TYPE.SUBMITTED ||
          status === APPLICATION_STATUS_TYPE.UNDER_SUPERVISOR
        );
      },
    },
  ];

  // Enable department filter for supervisor application list
  // As some supervisors are joint-appointed by multiple departments
  const hiddenFilters: FilterFields[] = React.useMemo(
    () => [
      'partnerCategory',
      'applicantIdentityType',
      'applicantLocalIndicator',
      'gsAssignee',
    ],
    [],
  );

  const listFilter = supervisorApplicationListFilter(user);

  const visibleColumns: TableColumns[] = React.useMemo(
    () => [
      'applicationNo',
      'applicantName',
      'entryYear',
      'applyProgramme',
      'department',
      'researchAreas',
      'scholarshipApplications',
      'hkpfsDisplayInformation',
      'nominatedFundings',
      'applicationSubmissionTime',
      'applicationStatus',
    ],
    [],
  );

  const quickFilters = [
    {
      id: 'TO_DO',
      text: 'TO-DO',
      filter: supervisorToDoFilter(user),
      isDefault: true,
    },
    { id: 'ALL', text: 'ALL', filter: supervisorApplicationListFilter(user) },
  ];

  const filterProps: ApplicationViewListProps['filterProps'] = {
    hiddenFilterFields: hiddenFilters,
  };
  const tableProps: ApplicationViewListProps['tableProps'] = {
    initialVisibleColumns: visibleColumns,
    listFilter,
    customActions,
  };
  const quickFilterProps: ApplicationViewListProps['quickFilterProps'] = {
    quickFilters,
  };

  return (
    <ApplicationViewList
      tableProps={tableProps}
      filterProps={filterProps}
      quickFilterProps={quickFilterProps}
    />
  );
};
